// Static roster data is safe to hold for a full event day. 24h covers
// the warm-up window (30 min before doors) + a typical 12-18h event,
// plus headroom for late scans.
export const CHECKIN_ROSTER_TTL_SECONDS = 60 * 60 * 24;

// Zone access rules can change mid-event (ops edits an access list).
// Keep TTL short so an edit propagates within minutes without needing
// explicit invalidation everywhere.
export const CHECKIN_RULES_TTL_SECONDS = 60 * 10;

// Cache key helpers live next to the TTLs so producers and consumers
// import from a single source of truth. NEVER inline these strings.
// Env segment is prepended by @sajilni/cache SajilniCache.key() via getCacheEnv()
// (e.g. sajilni:staging:checkin:roster:…).
export const checkinRosterKey = (orderItemId: string) =>
  `checkin:roster:${orderItemId}`;

export const checkinRulesKey = (zoneId: string) =>
  `checkin:rules:zone:${zoneId}`;

/** Last manual/cron warm result for an event (ops UI + dedupe). */
export const checkinWarmMetaKey = (eventId: string) =>
  `checkin:warm-meta:${eventId}`;
